export const spRoutes = [
    { key: 'SPRS', route: '/shipment-portal/rate-shop' },
    { key: 'SPTT', route: '/shipment-portal/track' },
    { key: 'SPUF', route: '/shipment-portal/upload-file' },
    { key: 'SPAS', route: '/shipment-portal/add' },
    { key: 'SPSD', route: '/shipment-portal/support' },
    { key: 'SPMS', route: '/shipment-portal/manage' },
    { key: 'RPIS', route: '/shipment-portal/reports/inbound' },
    { key: 'RPOS', route: '/shipment-portal/reports/outbound' },
    { key: 'RPDS', route: '/shipment-portal/reports/delayed' },
    { key: 'RPTS', route: '/shipment-portal/reports/in-transit' },
    { key: 'RPRD', route: '/shipment-portal/reports/recently-delivered' }
];
